import { GenericAbortSignal } from 'axios';

import { Classification, ClassificationOptions } from 'models/flexible/Classification';
import { Paginated } from 'models/flexible/Paginated';
import type {
  AdminClassificationCreateParams,
  AdminClassificationIndexFields,
  AdminClassificationIndexInclude,
  AdminClassificationUpdateParams,
} from 'services/api/fields';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminClassificationsQueryKeys = {
  index: (params?: Record<string, any>) => ['adminClassifications', params] as const,
};

const URL = 'admin/classifications';

export type AdminClassificationIndexParams = BaseIndexQueryParams & {
  type?: string;
  client?: string;
  parentClassificationId?: string;
};

export async function adminIndexClassifications<I extends AdminClassificationIndexInclude = never>(
  params: AdminClassificationIndexParams,
  signal?: GenericAbortSignal,
  includes?: I[]
): Promise<Paginated<Classification<AdminClassificationIndexFields<I>>>> {
  return http
    .get<
      Paginated<ClassificationOptions>
    >(URL, { params: { ...params, ...(includes?.length ? { include: includes.join(',') } : {}) }, signal })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((x) => new Classification(x)),
    })) as unknown as Promise<Paginated<Classification<AdminClassificationIndexFields<I>>>>;
}

export async function createClassification(params: AdminClassificationCreateParams) {
  return http.post<ClassificationOptions>(URL, params).then((res) => new Classification(res.data));
}

export async function updateClassification(id: string, params: AdminClassificationUpdateParams) {
  return http.patch<ClassificationOptions>(`${URL}/${id}`, params).then((res) => new Classification(res.data));
}
